import { makeTile, type Tile } from '../types.js';
import type { DominoRuleSet } from './types.js';

/**
 * Козёл opening order: [1|1], then the remaining doubles ascending. When
 * none was dealt, `pickFirstHandLead` falls back to the lowest tile.
 */
export const GOAT_FIRST_HAND_PRIORITY: readonly Tile[] = [
  makeTile(1, 1),
  makeTile(0, 0),
  makeTile(2, 2),
  makeTile(3, 3),
  makeTile(4, 4),
  makeTile(5, 5),
  makeTile(6, 6),
];

/** The side whose recorded penalties reach this total loses the match. */
export const GOAT_POINT_GOAL = 101;

/**
 * Козёл — the Russian courtyard game. Plain line (no spinner), no scoring
 * during play: when a hand ends the losers record their remaining pips as
 * penalties, and the side that reaches 101 is the «козёл». Scoring lives in
 * the `penalty` `ScoringPolicy`; the Muggins/fives fields are inert here.
 */
export const GOAT: DominoRuleSet = {
  id: 'goat',
  setSize: 28,
  maxPip: 6,
  handSize: { 2: 7, 3: 7, 4: 7 },
  pointGoal: GOAT_POINT_GOAL,
  drawRule: 'draw-until-playable',
  spinner: false,
  mugginsStrict: false,
  mugginsClaimWindowMs: 0,
  scoreMultiple: 5,
  scoring: 'penalty',
  partnership: false,
  firstHandLeadPriority: GOAT_FIRST_HAND_PRIORITY,
  leadScoresOnlyOnDoubleFive: false,
  nextHandLeader: 'winner',
  opening13: false,
  baldFinish: false,
};

export const GOAT_PARTNERSHIP: DominoRuleSet = {
  ...GOAT,
  id: 'goat-2v2',
  partnership: true,
};
